import { render, staticRenderFns } from "./aboutLxwm.vue?vue&type=template&id=119a8a46&scoped=true&"
import script from "./aboutLxwm.vue?vue&type=script&lang=js&"
export * from "./aboutLxwm.vue?vue&type=script&lang=js&"
import style0 from "./aboutLxwm.vue?vue&type=style&index=0&id=119a8a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a8a46",
  null
  
)

export default component.exports